import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-kundengruppe-kundengrp-list-view',
  imports: [],
  templateUrl: './kundengruppe-kundengrp.list-view.html',
  styleUrls: ['./kundengruppe-kundengrp.list-view.css'],
})
export class KundengruppeKundengrpListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
